import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreViolationReportsModule } from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { ViolationReportErrorComponent } from './violation-report-error/violation-report-error.component';
import { ViolationReportModalComponent } from './violation-report-modal.component';

@NgModule({
  imports: [
    CommonModule,
    TrackingModule,
    UiModule,
    DatastoreViolationReportsModule,
  ],
  declarations: [ViolationReportErrorComponent, ViolationReportModalComponent],
})
export class ViolationReportModalModule {}
